module.exports = __webpack_public_path__ + "img/c14ac95.png";